export enum SantanderSuitabilityCookieKeys {
  isExpired = 'santander-suitability-is-expired',
  profileName = 'santander-suitability-profile-name',
}
